<template>
    <van-row style="margin-left: 5px; font-weight: bold; margin-top: 5px; min-height: 10px">
        <van-col span="6">
            <JdSortButton id="sort1" width="100%"
                          style="text-align: center"
                          :value="synthetical_value"
                          :label="synthetical_label"
                          @onSelect="onSortSelect">
                <div slot="right-icon"></div>
                综合排序
            </JdSortButton>
        </van-col>
        <van-col span="6">
            <JdSortButton id="sort2" width="100%" btnType="order"
                          style="text-align: center"
                          :value="price_value"
                          :label="price_label"
                          @onSelect="onSortSelect">
                价格
            </JdSortButton>
        </van-col>
        <van-col span="6">
            <JdSortButton id="sort3" width="100%" btnType="order"
                          style="text-align: left"
                          :value="commissionShare_value"
                          :label="commissionShare_label"
                          @onSelect="onSortSelect">
                佣金比例
            </JdSortButton>
        </van-col>
        <van-col span="6">
            <JdSortButton id="sort4" width="100%" btnType="order"
                          style="text-align: left"
                          :value="inOrderCount30Days_value"
                          :label="inOrderCount30Days_label"
                          @onSelect="onSortSelect">
                月销量
            </JdSortButton>
        </van-col>
    </van-row>
</template>

<script>

    import JdSortButton from "../../custom/JdSortButton";
    export default {
        name: "TbSortTabs",
        components: {JdSortButton},
        data(){
            return{
                //综合排序是否被选中
                synthetical_value: true,
                //佣金排序是否被选中
                price_value: false,
                //佣金比例排序是否被选中
                commissionShare_value: false,
                //月销量排序是否被选中
                inOrderCount30Days_value: false,

                //综合排序标签识别
                synthetical_label: "synthetical",
                //佣金排序标签识别
                price_label: "price",
                //佣金比例标签识别
                commissionShare_label: "tk_rate",
                //月销量排标签识别
                inOrderCount30Days_label: "total_sales",
            }
        },
        methods:{
            /**
             * 排序选项被选中
             */
            onSortSelect(label, check, sort) {

                if (label === this.synthetical_label) {
                    this.synthetical_value = true;
                    this.price_value = false;
                    this.commissionShare_value = false;
                    this.inOrderCount30Days_value = false;
                    if (check) {
                        // this.all_params.sortName = "";
                        // this.all_params.sort = sort;
                        this.$emit("onSelect", "", sort)
                    }else{
                        // this.all_params.sortName = "";
                        // this.all_params.sort = "";
                        this.$emit("onSelect", "", "")
                    }

                } else {
                    if (label === this.price_label) {
                        this.synthetical_value = false;
                        this.price_value = true;
                        this.commissionShare_value = false;
                        this.inOrderCount30Days_value = false;
                    } else if (label === this.commissionShare_label) {
                        this.synthetical_value = false;
                        this.price_value = false;
                        this.commissionShare_value = true;
                        this.inOrderCount30Days_value = false;
                    } else if (label === this.inOrderCount30Days_label) {
                        this.synthetical_value = false;
                        this.price_value = false;
                        this.commissionShare_value = false;
                        this.inOrderCount30Days_value = true;
                    }
                    // this.$log("this.synthetical_value = " + this.synthetical_value)
                    // this.$log("this.price_value = " + this.price_value)
                    // this.$log("this.commissionShare_value = " + this.commissionShare_value)
                    // this.$log("this.inOrderCount30Days_value = " + this.inOrderCount30Days_value)

                    // this.all_params.sortName = label;
                    // this.all_params.sort = sort;
                    this.$emit("onSelect", label, sort)
                }
            },

            /**
             * 初始化状态
             */
            initSortStatus(){
                this.synthetical_value = true;
                this.price_value = false;
                this.commissionShare_value = false;
                this.inOrderCount30Days_value = false;
            },
        }
    }
</script>

<style scoped>

</style>